import { render, staticRenderFns } from "./RiskConferenceSafety.vue?vue&type=template&id=d1835986&scoped=true&"
import script from "./RiskConferenceSafety.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1835986",
  null
  
)

export default component.exports